// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2HZui","label":"Completed_label__2I6Ii"};